export default function makeFields(options) {
  const keys = Object.keys(options);
  const out = {};
  for (var key of keys) {
    const property = options[key];
    out[key] = {
      get: function () {
        return this.$store.getters[property];
      },
      set: function (value) {
        this.$store.commit(property, value);
      },
    };
  }
  return out;
}
